import { h } from "@stencil/core";
import { TableCellProps } from "../table-cell";

export const renderTextAndDate = ({
    item,
    columnKey,
    schemaItem,
}: TableCellProps) => {
    const { dateKey } = schemaItem;
    const locale = document.documentElement.getAttribute("lang") || "en";
    const day = new Intl.DateTimeFormat(locale, {
        day: "2-digit",
    });
    const month = new Intl.DateTimeFormat(locale, {
        month: "short",
    });
    const plainDate = new Date(item[dateKey]); // UTC date
    const date = new Date(
        Date.UTC(
            plainDate.getFullYear(),
            plainDate.getMonth(),
            plainDate.getDate(),
            plainDate.getHours()
        )
    );
    return (
        <td data-sort={item[columnKey]} data-testid={columnKey}>
            <div class="ux-iws-table-header__date">
                <div class="ux-iws-table-header__date__month">
                    {day.format(date)}
                </div>
                {month.format(date)}
            </div>

            <span
                class="ux-iws-table-header--text-and-date"
                style={{ top: "2.2em" }}
            >
                {item[columnKey]}
            </span>
        </td>
    );
};
